<template>
  <div>
    <div class="cricket-stats">
      <h2>Best Batting</h2>
        <div class="stats-box col3">
          <player-stats-item
            v-for="metric in bat"
            :key="metric[0]"
            :name="metric[0]"
            :stats="metric[1]">
          </player-stats-item>
        </div>
    </div>

    <div class="cricket-stats">
      <h2>Best Bowling</h2>
        <div class="stats-box">
          <player-stats-item
            v-for="metric in bowl"
            :key="metric[0]"
            :name="metric[0]"
            :stats="metric[1]">
          </player-stats-item>
        </div>
    </div>
  </div>

</template>
<script>
import  PlayerStatsItem  from '@/components/cricket/PlayerStatsItem'

export default {
  components : {
    'PlayerStatsItem': PlayerStatsItem
  },
  props: {
    teamKey: String,
    stats: Object
  },

  data () {
    const batsman = this.stats.top_players.batsman
    const bowler = this.stats.top_players.bowler

    const bat = [
      ["Most Runs", this.buildStatsItems(batsman.most_runs)],
      ["Most Hundreds", this.buildStatsItems(batsman.most_hundreds)],
      ["Most Fifties", this.buildStatsItems(batsman.most_fifties)],
      ["Most Thirties", this.buildStatsItems(batsman.most_thirties)],
      ["Most Sixes", this.buildStatsItems(batsman.most_sixes)],
      ["Most Fours", this.buildStatsItems(batsman.most_fours)],
    ]

    const bowl = [
      ["Most Wickets", this.buildStatsItems(bowler.most_wickets)],
      ["Best Economy", this.buildStatsItems(bowler.best_economy_innings)],
      ["Most 5 wickets", this.buildStatsItems(bowler.most_five_wickets_inngins)],
      ["Most 3 wickets", this.buildStatsItems(bowler.most_three_wickets_inngins)],
    ]

    return {
      bat,
      bowl
    }
  },

  methods: {
    buildStatsItem(item) {
      return {
        name: item.player,
        key: item.player,
        value: item.total
      }
    },
    buildStatsItems(items) {
      let newItems = []
      items.forEach((item)=> {
        newItems.push(this.buildStatsItem(item))
      })

      return newItems
    }
  },
}
</script>
